// Turkish Bazar: barra fija de compra en celular (snippets/sticky-add-to-cart.liquid)
if (!customElements.get('sticky-add-to-cart')) {
  customElements.define(
    'sticky-add-to-cart',
    class StickyAddToCart extends HTMLElement {
      connectedCallback() {
        this.sectionId = this.dataset.section;
        this.productInfo = this.closest('product-info');
        this.button = this.querySelector('.sticky-atc__button');
        this.priceEl = this.querySelector('.sticky-atc__price');
        if (!this.mainButton || !this.productInfo) return;

        this.button.addEventListener('click', () => this.mainButton.click());

        // Mostrar solo cuando el botón principal quedó arriba, fuera de la pantalla.
        // Con scroll y no IntersectionObserver: un salto que pasa de largo el botón sin
        // que llegue a verse (link interno, recarga a mitad de página) no dispara el observer.
        this.onScroll = () => {
          if (this.ticking) return;
          this.ticking = true;
          requestAnimationFrame(() => {
            this.ticking = false;
            const button = this.mainButton;
            if (button) this.toggle(button.getBoundingClientRect().bottom < 0);
          });
        };
        window.addEventListener('scroll', this.onScroll, { passive: true });
        this.onScroll();

        // Al cambiar de variante Dawn reescribe precio y botón: copiar de nuevo
        // (ignorando las mutaciones de la propia barra, que también vive dentro de product-info)
        this.mutationObserver = new MutationObserver((mutations) => {
          if (mutations.some((mutation) => !this.contains(mutation.target))) this.sync();
        });
        this.mutationObserver.observe(this.productInfo, {
          subtree: true,
          childList: true,
          attributes: true,
          attributeFilter: ['disabled', 'class'],
        });
        this.sync();
      }

      disconnectedCallback() {
        window.removeEventListener('scroll', this.onScroll);
        this.mutationObserver?.disconnect();
        document.body.classList.remove('sticky-atc-visible');
      }

      get mainButton() {
        return document.getElementById(`ProductSubmitButton-${this.sectionId}`);
      }

      toggle(visible) {
        if (visible === this.classList.contains('is-visible')) return;
        this.classList.toggle('is-visible', visible);
        this.setAttribute('aria-hidden', String(!visible));
        this.button.tabIndex = visible ? 0 : -1;
        document.body.classList.toggle('sticky-atc-visible', visible);
      }

      sync() {
        const mainButton = this.mainButton;
        if (mainButton) {
          if (this.button.disabled !== mainButton.disabled) this.button.disabled = mainButton.disabled;
          const label = mainButton.querySelector('span')?.textContent.trim();
          if (label && this.button.textContent.trim() !== label) this.button.textContent = label;
        }

        const price = document.getElementById(`price-${this.sectionId}`);
        if (!price) return;
        const onSale = price.querySelector('.price--on-sale');
        const current = onSale
          ? price.querySelector('.price__sale .price-item--sale')
          : price.querySelector('.price__regular .price-item--regular');
        const text = current?.textContent.trim();
        if (text && this.priceEl.textContent !== text) this.priceEl.textContent = text;
      }
    }
  );
}
